<template>
<div class="chapter">
<div class="inner_page">
<div class="book"><h1 style="text-align:center;"></h1><div class="verse"><i> For all our darlings whose</i><br/></div><div class="verse"><i> gifts were lost too soon—</i><br/></div><div class="verse"><i> would any of these</i><br/></div><div class="verse"><i> could have saved you for us</i><br/></div><p></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?8a764370